import type { ComponentProps } from 'react';
import React from 'react';

import { cn } from '../cn';
import { buttonTextAndBorder } from '../common';
import { ButtonPropsSizeType } from '../common.type';
import InputTitle from './InputTitle';
import TextareaValue from './TextareaValue';

export type TextareaProps = Omit<ComponentProps<'textarea'>, 'size'> & {
  size?: ButtonPropsSizeType;
  error?: string;
  subtitle?: string;
  titleClassName?: string;
  textAreaClassName?: string;
  onCmdClickSubmit?: (e: React.SyntheticEvent<Element, Event>) => void;
};

export default function Textarea({
  size,
  title,
  subtitle,
  error,
  className,
  titleClassName,
  textAreaClassName,
  ref,
  ...props
}: TextareaProps) {
  return (
    <div
      className={cn(
        'inline-flex min-w-28 flex-col text-slate-600 dark:text-slate-100',
        {
          'gap-1': size === 'md' || size == null,
          'min-w-22 gap-0.5': size === 'sm',
          'min-w-18 gap-0': size === 'xs',
        },
        className,
      )}>
      {title && (
        <InputTitle error={error} size={size} className={titleClassName}>
          {title}
        </InputTitle>
      )}
      <div
        className={cn(
          'inline-flex overflow-hidden border font-sans transition-colors',
          'border-slate-200 bg-white focus-within:bg-apricot-white-50',
          'dark:border-charade-700 dark:bg-charade-950 dark:focus-within:bg-charade-800',
          {
            'border-fair-pink-300 bg-fair-pink-100 text-fair-pink-600 dark:border-fair-pink-900 dark:bg-fair-pink-950 dark:text-fair-pink-700 dark:focus-within:bg-fair-pink-900':
              error,
          },
          buttonTextAndBorder(size),
        )}>
        <TextareaValue {...props} size={size} error={error} ref={ref} className={textAreaClassName} />
      </div>
      {subtitle && <InputTitle size={size}>{subtitle}</InputTitle>}
    </div>
  );
}
